/** sessionStorage keys for pending staff invite across auth redirects. */
export const STAFF_INVITE_TOKEN_KEY = 'pendingStaffInviteToken';
export const STAFF_INVITE_EMAIL_KEY = 'pendingStaffInviteEmail';

export function storeStaffInviteToken(token: string) {
    if (!token) return;
    const previous = sessionStorage.getItem(STAFF_INVITE_TOKEN_KEY);
    if (previous && previous !== token) {
        sessionStorage.removeItem(STAFF_INVITE_EMAIL_KEY);
    }
    sessionStorage.setItem(STAFF_INVITE_TOKEN_KEY, token);
}

export function readStaffInviteToken(): string | null {
    return sessionStorage.getItem(STAFF_INVITE_TOKEN_KEY);
}

export function storeStaffInviteEmail(email: string) {
    if (!email) return;
    sessionStorage.setItem(STAFF_INVITE_EMAIL_KEY, email.toLowerCase().trim());
}

export function readStaffInviteEmail(): string | null {
    return sessionStorage.getItem(STAFF_INVITE_EMAIL_KEY);
}

export function clearStaffInviteToken() {
    sessionStorage.removeItem(STAFF_INVITE_TOKEN_KEY);
    sessionStorage.removeItem(STAFF_INVITE_EMAIL_KEY);
}

function responseStatus(error: unknown): number | undefined {
    return (error as { response?: { status?: number } })?.response?.status;
}

/** Wrong authenticated email — keep token so the user can switch accounts. */
export function isWrongAccountStaffInviteError(error: unknown): boolean {
    return responseStatus(error) === 403;
}

/** Session missing/expired — keep invite token; send user through sign-in again. */
export function isAuthRequiredStaffInviteError(error: unknown): boolean {
    return responseStatus(error) === 401;
}

/**
 * Terminal invite outcomes — clear the pending token so later logins are not
 * bounced to a dead accept page. Does NOT include network/5xx/timeouts, 401, or 403.
 */
export function isTerminalStaffInviteError(error: unknown): boolean {
    const status = responseStatus(error);
    if (status === undefined) return false;
    if (status === 404 || status === 409 || status === 410) return true;
    if (status === 400) return true;
    return false;
}
